import {Component, effect, EventEmitter, Input, model, Output, signal, Signal} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {NbSelectModule} from '@nebular/theme';
import {Division} from '../../../models/division';
import {StorageService} from "../../../services/storage.service";
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-division-selector',
  standalone: true,
  imports: [
    TranslateModule,NbSelectModule, FormsModule],
  templateUrl: './division-selector.component.html',
  styleUrl: './division-selector.component.scss'
})
export class DivisionSelectorComponent {
  @Input() selectedDivisionId!: Signal<string>;
  @Input() divisions!: Division[];
  selectedValue = model<string>('');
  @Output() divisionChanged = new EventEmitter();

  constructor(private storageService: StorageService) {
    effect(() => {
      this.selectedDivisionId();
      setTimeout(() => {
        this.selectedValue.set(this.selectedDivisionId())
      })
    });
  }

  divisionChange($event: any) {
    this.divisionChanged.emit($event);
    this.storageService.storeSelectedDivisionId($event);
  }
}
